import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import DropDown from 'components/DropDown';
import MenuItem from '@material-ui/core/MenuItem';
import FormElement from 'components/FormElement';
import { Body1, Subtitle2, H4 } from 'components/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CardDisplay from '../CardDisplay';
import DialogHeader from 'components/DialogHeader';
import { Mobile, Default } from 'components/Responsive';
import classNames from 'classnames';
import styles from './styles';
import m from 'messages';
import isStringSet from 'utilities/is/isStringSet';

class JobRoleSelectionView extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedJobRoleID: props.card.selectedJobRoleID || 'NULL'
        };
    }

    handleClose = () => {
        this.props.close();
    };

    jobRoleChanged = (e) => {
        const jobRoleId = e.target.value;
        this.props.card.selectedJobRoleID = jobRoleId;
        this.setState({ selectedJobRoleID: jobRoleId });

        if (this.props.hasOwnProperty('handleJobRoleChanged')) {
            this.props.handleJobRoleChanged(jobRoleId);
        }
    };

    cardHolderView() {

        const { card, classes, location } = this.props;

        let divisionJobRoleId = null;
        let divisionId = null;

        if (location.division) {
            divisionId = (location.division.divisionID || '').toLowerCase();
            divisionJobRoleId = location.division.divisionJobRoleID;
        }

        const jobRolesToShow =
            this.jobRolesToShow(
                card.jobRolesArray,
                divisionId,
                divisionJobRoleId);

        const showJobRoles = jobRolesToShow.some(x => x.id !== 'NULL');
        const selectedJobRoleId = (this.state.selectedJobRoleID || 'NULL').toUpperCase();

        return (
            <Grid container spacing={2} className={classes.margin}>
                <Grid item xs={12}>
                    <H4 paragraph>{m.cards.cardholderOverviewHeader}</H4>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <CardDisplay card={card} />
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormElement className={classes.dropdown} fullWidth>
                        <Subtitle2>
                            {m.cards.jobRole}
                        </Subtitle2>
                        {showJobRoles ?
                            <DropDown
                                value={selectedJobRoleId || ''}
                                onChange={this.jobRoleChanged}>

                                {jobRolesToShow.map((item, index) =>
                                    <MenuItem key={index} value={item.id}>{item.name} {item.division ? `(${item.division})` : ''}</MenuItem>
                                )}
                            </DropDown>
                            : <Body1>No valid job roles</Body1>}
                    </FormElement>
                </Grid>
            </Grid>);
    }

    jobRolesToShow = (jobRoles, currentDivisionId, divisionJobRoleId) => {

        let filtered = (jobRoles || []).filter(j => !isStringSet(j.divisionID) || j.divisionID.toLowerCase() === currentDivisionId);

        if (isStringSet(divisionJobRoleId)) {
            divisionJobRoleId = divisionJobRoleId.toLowerCase();

            let head = filtered.filter(j => j.id.toLowerCase() === divisionJobRoleId);
            let others = filtered.filter(j => j.id.toLowerCase() !== divisionJobRoleId);

            filtered = [{ id: 'NULL', name: m.cards.jobRoleNotSelected, division: '' }].concat(others);

            if (head.length > 0) {
                filtered = head.concat(filtered);
            }
        } else {
            filtered = [{ id: 'NULL', name: m.cards.jobRoleNotSelected, division: '' }].concat(filtered);
        }

        return filtered;
    };

    render() {
        const {
            card,
            classes
        } = this.props;

        const actions = React.Children.map(this.props.children, (child, index) =>
            React.cloneElement(child, {
                key: index,
                className: classNames(classes.actionButtons, child.props.className)
            }));

        return (
            <div>
                {card &&
                    <Dialog
                        fullScreen
                        open={true}>
                        <DialogHeader
                            title={m.spotCheck.jobRoleSelection.title}
                            handleClose={this.handleClose}
                            disableClose={false}
                            showBackIcon={true}
                            icon={this.props.icon} />
                        <DialogContent className={classes.contentRoot}>
                            <Mobile>
                                <AppBar position="static" color="default" elevation={0}>

                                </AppBar>
                                <div className={classes.contentBody}>
                                    {this.cardHolderView()}
                                </div>
                            </Mobile>
                            <Default>
                                <div className={classes.contentBodyWide}>
                                    <section className={classes.section}>
                                        {this.cardHolderView()}
                                    </section>
                                </div>
                            </Default>
                        </DialogContent>
                        <DialogActions className={classes.actionRoot}>
                            {actions}
                        </DialogActions>
                    </Dialog>
                }
            </div>);
    }
}

export default withStyles(styles)(JobRoleSelectionView);